subscription TravelAuthorizationDocumentPackageStatus($id: UUID!) {
  travelAuthorizationDocumentPackageStatus(id: $id) {
    document {
      id
    }
    status
  }
}
